// ...existing code...
import DOMHelpers from './utils/dom-helpers';
import { debounce as _debounce } from 'es-toolkit';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class Layout {

	constructor(options) {

		// OPTIONS
		this.defaults = {
			main: undefined,
			skip_intro: false
		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace = 'layout';

		this.main = this.options.main;

		// DOM helpers
		this.dom = new DOMHelpers(document);

		// VARS (vanilla DOM)
		this.window = window;
		this.document = document;
		this.htmlEl = document.documentElement;
		this.body = document.body;

		// convenience shorthands
		this.qs = this.dom.qs.bind(this.dom);
		this.qsa = this.dom.qsa.bind(this.dom);
		this.on = this.dom.on.bind(this.dom);
		this.off = this.dom.off.bind(this.dom);
		this.addClass = this.dom.addClass.bind(this.dom);
		this.removeClass = this.dom.removeClass.bind(this.dom);
		this.hasClass = this.dom.hasClass.bind(this.dom);
		this.htmlToDoc = this.dom.htmlToDoc.bind(this.dom);

		this.init()

	}

	init() {

		// this.initMainMenu();
		// this.initSearch();
		// this.paintMenu( document.location.href );
		this.initMobile();
		// this.checkHash();

		this.debounceResize(true);
		setTimeout(() => this.onResize(), 17);

	}



	// -----------------------------------------------------------------[ RESIZE HANDLER ]--------------------------------------------------------------//
	debounceResize(b) {
		if (b) {
			// debounce resize
			this._debResize = _debounce(() => this.onResize(true), 17);
			window.addEventListener('resize', this._debResize);
			// Listen for orientation changes
			this._onOrientation = () => this.onOrientationChange();
			window.addEventListener('orientationchange', this._onOrientation, false);
		}
		else {
			if (this._debResize) {
				this._debResize.cancel && this._debResize.cancel();
				window.removeEventListener('resize', this._debResize);
			}
			if (this._onOrientation) {
				window.removeEventListener('orientationchange', this._onOrientation, false);
				this._onOrientation = null;
			}
		}
	}

	onOrientationChange() {
		//console.log( 'onOrientationChange');
		if (this.id_orient) clearTimeout(this.id_orient);
		this.id_orient = setTimeout(() => this.onResize(true), 77);
	}

	onResize(_b) {

		// Variables available for future layout calculations
		// let w = window.innerWidth || document.documentElement.clientWidth,
		// 	h = window.innerHeight || document.documentElement.clientHeight;

		// this class is used for layouts that need to be resized before revealed. For example .home-MAIN-promo (opacity=0 and resized opacity 1)
		this.addClass(this.body, 'resized');
		//this.qs( '#background' ).style.height = this.window.innerHeight + 'px';

		// place any resize dependent code here, using w and h
	}



	/*
	clearAllMenuSelections() {
	}
	*/


	paintMenuURL(url) {
		const menus= this.qsa('.menu'),
			menu_views 	= this.qsa('.menu-view');


		menus.push( ...menu_views );

		const current = 'current-menu-item';
		const unselected = 'state-all-unselected';

		//console.log( menus );


		menus.forEach((mnu, i) => {

			const lis = Array.from(mnu.querySelectorAll('li'));
			let found = false;

			// clear classes on all li
			lis.forEach(li => {
				li.classList.remove('current-menu-item', 'current-menu-parent', 'current-page-ancestor', 'current_page_item');
			});


			if ( location.origin + '/' !== url ){ // if it's not homepage
				// find which one is selected
				lis.forEach(li => {
					const a = li.querySelector('a');
					if (!a) return;
					const href = a.getAttribute('href');
					//console.log( url + ', href=' + href );
					if (href === url || url.indexOf( href ) !== -1 || this.hasClass(a,'force-select') ) {

						//console.log( 'FOUND! . url =' +  url + ', href=' + href );

						li.classList.add(current);
						found = true;
					}
				});

			}

			// if there is no selection -> unselected
			if (!found) {
				lis.forEach(li => li.classList.add(unselected));
			}
		});

		// special cases ( mostly single templates, taxonomies and categories, sub-pages )
		if (this.hasClass(this.body, 'single-artwork') || this.hasClass( this.body, 'single-artist' ) || this.hasClass(this.body, 'tax-region') || this.hasClass(this.body, 'tax-material-medium') ) {
			this.setMenuSelection( this.qsa( '.desktop-menu' ), 0, current, unselected );
		}
		if (this.hasClass(this.body, 'single-initiative')) {
			this.setMenuSelection( this.qsa( '.desktop-menu' ), 1, current, unselected );
		}
	}

	setMenuSelection( menus, index, current, unselected) {
		menus.forEach((mnu, i) => {
			const lis = Array.from(mnu.querySelectorAll('li'));
			lis[ index ].classList.add(current);
		});
	}


	//----------------------------------------------------------- MOBILE ---------------------------------------//


	initMobile() {
		const btn = this.qs('#mobile-panel-open');
		const close = this.qs('#mobile-panel-close');
		const bg 	= this.qs( '#menu-panel .bg' );
		if (btn) this.on(btn, 'click', (e) => this.toggleDrawerMobile(e));
		if (close) this.on(close, 'click', (e) => this.openDrawerMobile(false, e));
		if (bg) this.on( bg, 'click', (e) => this.openDrawerMobile(false, e));
	}

	toggleDrawerMobile(e) {
		if (e) e.preventDefault();
		this.openDrawerMobile(!this.hasClass(this.body, 'menu-mobile-open'));
	}

	openDrawerMobile(b, e) {
		if (e) e.preventDefault();
		const scrollEl = this.qs('#menu-panel .content-wrap');
		const openBtn = this.qs('#mobile-panel-open');
		const closeBtn = this.qs('#mobile-panel-close');
		if (!scrollEl) return;
		if (b) {
			if (!this.hasClass(this.body, 'menu-mobile-open')) {
				this.addClass(this.body, 'menu-mobile-open');
				disableBodyScroll(scrollEl);
				// Update ARIA attributes
				if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
				if (closeBtn) closeBtn.setAttribute('aria-expanded', 'true');
			}
		}
		else {
			if (this.hasClass(this.body, 'menu-mobile-open')) {
				this.removeClass(this.body, 'menu-mobile-open');
				enableBodyScroll(scrollEl);
				// Update ARIA attributes
				if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
				if (closeBtn) closeBtn.setAttribute('aria-expanded', 'false');
			}
		}
	}


	/*
	initMobileSearch(){
		const s = this.qs('#drawer-mobile .search');
		const input = this.qs('#drawer-mobile .searchfield');
		if (!s || !input) return;
		this.on(s, 'click', () => {
			this.addClass(this.qs('#drawer-mobile'), 'activate-search');
			input.focus();
		});
		this.on(input, 'blur', () => {
			this.removeClass(this.qs('#drawer-mobile'), 'activate-search');
		});
	}
	*/

	/*
	resetMobileMenu(){
		const items = this.qsa('#menu-mobile-menu > li');
		items.forEach(li => {
			if (li.classList.contains('menu-item-has-children')) {
				const a = li.querySelector('> a');
				if (a && a.dataset.open) {
					a.click();
				}
			}
		});
		const scrollPanel = this.qs('#scroll-panel');
		if (scrollPanel) scrollPanel.scrollTop = 0;
	}
	*/

	checkLogoHomeTransition(data ) {
		if ( !data || !data.next ) return;
		//console.log( data )


		if( data.next.namespace === 'home' && !this.dom.hasClass( this.htmlEl, 'end-logo-anim' ) ){
			//console.log( "HOMEPAGE - hide logo" );
			let el 		= this.dom.qs( '#header .logo' );
			el.style.opacity = 0; //'none';

			el 			= this.dom.qs( '#header-mobile .logo' );
			el.style.opacity = 0; //'none';

		}


		/*
		if ( !this.dom.hasClass( this.body, 'home' ) ) return;
		if ( this.dom.hasClass( this.htmlEl, 'end-logo-anim' ) ) return;

		const el 		= this.dom.qs( '#header .logo' ),
		*/

	}


	onBarbaChangeState(state, data) {
		switch (state) {
			case 'before':
				
				//this.openDesktopMenu( false );
				//this.openDrawerMobile( false );
				break;
			case 'beforeEnter':
				this.checkLogoHomeTransition(data);
				this.paintMenuURL(document.location.href);
				this.onResize();
				break;
			case 'after':
				// this.checkHash();
				break;
		}
	}

}